// NOTE: The string representation should correspond to the one provided in Facebook API
enum FacebookPhotoType {
    Uploaded = 'uploaded',
    Tagged = 'tagged',
}

export default FacebookPhotoType;
